import React from 'react';
import { Modal } from 'react-bootstrap';

export const ProductModal = ({ title, text, image, link, showModal, hideModal, screenShot, visitButton }) => {
	const backgroundImage = {
		backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.7)),url('${require('../../../assets/images/products')[screenShot]}')`,
	};

	return (
		<Modal show={showModal} onHide={hideModal} className="product-modal">
			<Modal.Body>
				<div className="app-preview" style={backgroundImage}>
					<img src={require('../../../assets/images/products')[image]} alt={title} />
				</div>
				<div className="app-details">
					<h3>{title}</h3>
					<p dangerouslySetInnerHTML={{ __html: `${text}` }} />
					{visitButton &&
					<div className="modal-btn-container">
						<a href={link} target='_blank' className="btn-style-seven">{visitButton}</a>
					</div>
					}
				</div>
			</Modal.Body>
		</Modal>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/Products/ProductModal.js